<template>
  <div class="container-fluid">
    <div class="row">
        <div class="col-md-offset-4 col-md-4">
            <card>
                <div class="header">
                    <h4 class="title">Login</h4>
                </div>
                <div class="content">
                    <form @submit.prevent.stop='login()'>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Username</label>
                                    <input type="text" v-model="username" name='username' class="form-control border-input" required placeholder="Username">
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Password</label>
                                    <input type="password" v-model="password" name='password' class="form-control border-input" required placeholder="Password">
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <button type="submit" class="btn btn-info btn-fill btn-wd">Login</button>
                            <!--<router-link class="btn btn-link" :to="{ name:  'Esqueci Minha Senha'}">Esqueci Minha Senha</router-link>-->
                        </div>
                        <div class="clearfix"></div>
                    </form>
                </div>
            </card>
        </div>
    </div>
</div>
</template>
<script>

import AuthService from '../services/auth-service'
import OverlayService from '../services/overlay-service';

export default {

  data () {
    return {
      username: undefined,
      password: undefined
    }
  },
  methods: {
    login() {

      OverlayService.trigger('show', true)
      
      AuthService.login(this.username, this.password).then(({ data }) => {
        this.$store.dispatch('login', data)
        this.$store.dispatch('getMembros')
        this.$store.dispatch('getObras')
        this.$store.dispatch('getAutores')
        this.$store.dispatch('getMidias')
        this.$store.dispatch('getIdiomas')
        this.$store.dispatch('getEditoras')
        this.$router.push('busca')
      }).catch(error => {
        if (error.response.status === 403) {
          this.$alertify.error(error.response.data.message || 'Login não autorizado')
        }
        else if (error.response.status === 401) {
          this.$alertify.error('Login não autorizado')
        } else if (error.response.status === 500) {
          this.$alertify.error('Erro no servidor')
        } else {
          this.$alertify.error('Erro ao fazer login: ' + error.status)
        }
      }).finally(() => {
        OverlayService.trigger('show', false)
      })
    }
  }

}
</script>

